import { MetaDataKeyModel } from '@em/models/restapi/MetaDataKey.Model';
import { ChangeTrackedCollectionModel } from '@shared/models/restapi/ChangeTrackedCollection.Model';

export class MetaDataKeyCollectionModel extends ChangeTrackedCollectionModel<MetaDataKeyModel> {
    public constructor() {
        super(MetaDataKeyModel);
    }
}
